module.exports = __webpack_public_path__ + "img/travel-agency__final-design-about-page.ef8aa46a.jpg";